module.exports = __webpack_public_path__ + "assets/2fea752a216526867f78076989b3ff22.mp3";